/**
 * TCB R15 Comparison Intelligence — eligibility wrapper around existing comparison UIs.
 * Never emits global brand scores. Blocked configs cannot be "recommended".
 */
(function (global) {
  'use strict';

  function isEligible(pkg) {
    if (!pkg) return false;
    var intel = pkg.intelligence || {};
    if (intel.purchase_mode === 'blocked') return false;
    if (intel.r12_surface_gate === 'blocked') return false;
    if ((intel.sku_count || 0) > 8) return false;
    return true;
  }

  function rankCandidates(packageIds, catalog, context) {
    var byId = {};
    (catalog.sub_packages || []).forEach(function (p) {
      byId[p.id] = p;
    });
    return (packageIds || [])
      .map(function (id) {
        return byId[id];
      })
      .filter(Boolean)
      .map(function (pkg) {
        var score = 0;
        if (context && context.legacy_facility_id && pkg.facility_id === context.legacy_facility_id) score += 40;
        if (isEligible(pkg)) score += 25;
        else score -= 1000;
        if (pkg.intelligence && pkg.intelligence.wet_signage_fulfillment === 'catalog_gap') score -= 5;
        return {
          package_id: pkg.id,
          eligible: isEligible(pkg),
          purchase_mode: (pkg.intelligence && pkg.intelligence.purchase_mode) || 'quote_preferred',
          score: score,
          recommended: false
        };
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .map(function (row, idx, arr) {
        if (idx === 0 && row.eligible && row.score > 0) row.recommended = true;
        if (!row.eligible) row.recommended = false;
        // Ensure only one recommended
        if (idx > 0) row.recommended = false;
        if (idx === 0 && !row.eligible) {
          for (var i = 1; i < arr.length; i++) {
            if (arr[i].eligible) {
              arr[i].recommended = true;
              break;
            }
          }
        }
        return row;
      });
  }

  function decorateDom(root, ranked) {
    if (!root || !ranked) return;
    ranked.forEach(function (row) {
      var el = root.querySelector('[data-package-id="' + row.package_id + '"], [data-compare-id="' + row.package_id + '"]');
      if (!el) return;
      el.setAttribute('data-tcb-eligible', row.eligible ? 'true' : 'false');
      el.setAttribute('data-tcb-recommended', row.recommended ? 'true' : 'false');
      el.setAttribute('data-tcb-purchase-mode', row.purchase_mode || '');
      if (!row.eligible) {
        el.classList.add('tcb-compare--blocked');
        var badge = el.querySelector('[data-tcb-compare-badge]');
        if (badge) badge.textContent = 'Not eligible';
      } else if (row.recommended) {
        el.classList.add('tcb-compare--recommended');
      }
    });
  }

  global.TCBComparisonIntelligence = {
    isEligible: isEligible,
    rankCandidates: rankCandidates,
    decorateDom: decorateDom
  };
})(typeof window !== 'undefined' ? window : globalThis);
